<template>
  <VManagersTable />
</template>
<script>
import VManagersTable from '@/components/Managers/VManagersTable'

export default {
  name: 'Managers',

  components: {
    VManagersTable
  }
}
</script>
